import {
  PRICING_MASTER_ENABLE_LOADING,
  PRICING_MASTER_DISABLE_LOADING,
  PRICING_MASTER_ENABLE_METADATA_LOADING,
  PRICING_MASTER_DISABLE_METADATA_LOADING,
  PRICING_MASTER_UPDATE_CHARGES,
  PRICING_MASTER_SET_SELECTED_CHARGE,
  PRICING_MASTER_UPDATE_TABLE_DATA,
  PRICING_MASTER_UPDATE_PAGINATION,
} from '../actions/constants';

const defaultState = {
  loading: false,
  metadataLoading: false,
  chargesData: [],
  selectedCharge: null,
  tableData: [],
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
    isNextPresent: false,
    lastIdNext: null,
    lastPrimarySortFieldNext: null,
    lastIdPrev: null,
    lastPrimarySortFieldValuePrev: null,
  },
};

export default function pricingMasterReducer(state = defaultState, action) {
  switch (action.type) {
    case PRICING_MASTER_ENABLE_LOADING:
      return { ...state, loading: true };
    case PRICING_MASTER_DISABLE_LOADING:
      return { ...state, loading: false };
    case PRICING_MASTER_ENABLE_METADATA_LOADING:
      return { ...state, metadataLoading: true };
    case PRICING_MASTER_DISABLE_METADATA_LOADING:
      return { ...state, metadataLoading: false };
    case PRICING_MASTER_UPDATE_CHARGES:
      return { ...state, chargesData: action.data };
    case PRICING_MASTER_SET_SELECTED_CHARGE:
      return { ...state, selectedCharge: action.data };
    case PRICING_MASTER_UPDATE_TABLE_DATA:
      return { ...state, tableData: action.data };
    case PRICING_MASTER_UPDATE_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    default:
      return state;
  }
}
